module.exports = __webpack_public_path__ + "static/media/zy_swiper_x.114c0150.jpg";